import { gql } from "@apollo/client";

export const lensDetailsScores = gql`
    fragment LensDetailsScoreWindow on LensScoreWindow {
        windowStart
        finalizationStatus
        totals {
            lensScore
            subscriberActionsUu
            subscribeCount
        }
        payout {
            state
            amountMilliUsd
            paidOn
            expectedBy
        }
    }

    query lensDetailsScores($input: LensScoresInput!) {
        lensScores(input: $input) {
            lensResults {
                unlockableId
                selectedMonth {
                    ...LensDetailsScoreWindow
                }
                priorClosedMonth {
                    ...LensDetailsScoreWindow
                }
            }
        }
    }
`;
